// extracted by mini-css-extract-plugin
export default {"list":"CompanyDetails_list__Ma7Fd","save":"CompanyDetails_save__n8O00"};